/**
 * Version 0.100
 *
 * Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
 * Copyright 2016 - 2026.
 *
 * !Changelog
 *
 * 2025
 * 29-09-2025
 * - [CHANGE] Unbind unnecessary events are gone
 * 2018
 * 	17-10-2018
 * 	- [BORN] This class is born. Hooray!
 *
 * !Usage
 *
 * 	-
 *
 * !Wishlist
 *
 * 	none
 */

var specific_interactions_init = {};

(function () {

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************

	this.onready = function () {

		/**
		 * Close the mobilemenu always on route
		 */
		specific_mobilemenu.toggle(1);

		/**
		 * Catch and active URL
		 */
		specific_interactions.catchAndActiveURL();

		/**
		 * Trigger: specific classes
		 */
		specific_reviews.onready();
		specific_scroller.checkUrl();
		specific_spotlight.onready();

		/**
		 * Set menu-items .js-noroute when page is 'home'
		 * and when url[1] is 'reserveren' remove .js-noroute
		 * from .js-nav-item
		 */
		if (
			url[2] === 'reserveren' || // nl
			url[2] === 'booking' || // en
			url[2] === 'reservierung' // de
		) {
			$('.js-nav-item').removeClass('js-noroute');
		} else {
			$('.js-nav-item').addClass('js-noroute');
		}

		/**
		 * If 'url[2]' is video, open popup
		 */
		if (url[2] === 'video') {
			popup.open(1, 1, 'video');
		}

		/**
		 * Init: Simple Lightbox
		 */
		$('.js-simplelightbox-media-interieur a').simpleLightbox({
			captions: false,
			close: true,
			showCounter: true,
			history: false,
			animationSpeed: 0,
			animationSlide: false,
			preloading: true,
			fadeSpeed: 0
		});

		$('.js-simplelightbox-media-exterieur a').simpleLightbox({
			captions: false,
			close: true,
			showCounter: true,
			history: false,
			animationSpeed: 0,
			animationSlide: false,
			preloading: true,
			fadeSpeed: 0
		});

		$('.js-simplelightbox-media-plattegrond a').simpleLightbox({
			captions: false,
			close: true,
			showCounter: true,
			history: false,
			animationSpeed: 0,
			animationSlide: false,
			preloading: true,
			fadeSpeed: 0
		});

		$('.js-simplelightbox-media-omgeving a').simpleLightbox({
			captions: false,
			close: true,
			showCounter: true,
			history: false,
			animationSpeed: 0,
			animationSlide: false,
			preloading: true,
			fadeSpeed: 0
		});

		$(document).on('click', '.js-trigger-lightbox-interieur', function (e) {
			e.preventDefault();
			setTimeout(function () {
				$('.js-simplelightbox-media-interieur a').first()[0].click();
			}, 100);
		});

		$(document).on('click', '.js-trigger-lightbox-exterieur', function (e) {
			e.preventDefault();
			setTimeout(function () {
				$('.js-simplelightbox-media-exterieur a').first()[0].click();
			}, 100);
		});


	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	// none

}).apply(specific_interactions_init);

